import React from "react";
import PropTypes from "prop-types";
import "../../../assets/scss/components/ui/cards/OwnerCard.scss";
import { usePlateWithVehicle } from "../../../hooks/useVehicleQuery";
import UserAvatar from "../avatar/UserAvatar";
import { Link } from "react-router-dom";
import { Chip, Tooltip, Typography } from "@mui/material";
import { Box } from "lucide-react";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
const OperatorCard = ({
  userId, 
  name, 
  lastName, 
  personImage, 
  documentNumber, 
  theme = "dark",
  vehicles = []
}) => {
  const cardClass = `owner-card ${theme === 'light' ? 'theme-light' : 'theme-dark'}`;
  // Estadísticas de vehículos
  const vehicleStats = {
    total: vehicles.length,
    trailers: vehicles.filter(v => v.is_trailer).length,
    regularVehicles: vehicles.filter(v => !v.is_trailer).length
  };

  return (
    <Link to={`/persons/profile/${userId}`} className="card-link">
      <div className={cardClass}>
        <div className="card-header">
          <div className="column first">
            <div className="column first-margenv1">
            <Typography variant="subtitle2" fontWeight="bold">
              {vehicleStats.total} vehículo{vehicleStats.total !== 1 ? 's' : ''}
            </Typography>
            </div>

            <div className="column first-margen"></div>
          </div>

          <div className="column second">
            <div className="column second-content">
            <Box display="flex" alignItems="center" mt={1} gap={1}>
              <Tooltip title="Vehículos regulares" arrow>
                <Chip 
                  size="small"
                  icon={<DirectionsCarIcon fontSize="small" />} 
                  label={vehicleStats.regularVehicles} 
                  color="primary"
                  variant="outlined"
                />
              </Tooltip>
              <Tooltip title="Remolques" arrow>
                <Chip 
                  size="small"
                  icon={<LocalShippingIcon fontSize="small" />} 
                  label={vehicleStats.trailers} 
                  color="secondary"
                  variant="outlined"
                />
              </Tooltip>
            </Box>
            </div>
            <div className="column second-margenv2"></div>
            <div className="column second-margenv3"></div>
          </div>
        </div>
        <div className="card-content">
          <div className="image-wrapper">
            <div className="image-border">
              <UserAvatar userId={userId} theme={theme} />
            </div>
          </div>
          <div className="info-wrapper">
            <div className="info">
              <div className="line"></div>
              <span className="text">{name || "Sin nombre"}</span>
            </div>
            <div className="info">
              <div className="line"></div>
              <span className="text">{lastName || "Sin apellido"}</span>
            </div>
            <div className="info">
              <div className="line"></div>
              <span className="text">{documentNumber || "No disponible"}</span>
            </div>
          </div>
        </div>
      </div>
    </Link>
  );
};

OperatorCard.propTypes = {
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  lastName: PropTypes.string,
  personImage: PropTypes.string,
  cellPhone: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  theme: PropTypes.oneOf(["light", "dark"]),
  vehicles: PropTypes.array,
};

export default OperatorCard;
